export default __webpack_public_path__ + "static/media/302.16e05359.jpg";